import { dayjs } from './dayjs';
import { dateTimeFormat } from './intl-cache';

export const formatCalendarDate = (date: Date, timeZone: string): string => {
  const parts = dateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);
  return ['year', 'month', 'day']
    .map((type) => parts.find((part) => part.type === type)!.value)
    .join('-');
};

export const parseCalendarDay = (value: string): Date => {
  const [year = 0, month = 1, day = 1] = value.split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const toCalendarDay = (date: Date): string =>
  [
    String(date.getFullYear()).padStart(4, '0'),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');

export const formatCalendarDay = (value: string, locale: string, pattern = 'L'): string =>
  dayjs(parseCalendarDay(value)).locale(locale.toLowerCase()).format(pattern);
